/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .controller('NodeGetLinkController', [
        '$scope', '$modalInstance', 'element', 'NodeShareLink',
        function ($scope, $modalInstance, element, NodeShareLink) {
            $scope.modal = $modalInstance.options;

            $scope.link = NodeShareLink.buildGetLinkFromFile(element);

            $scope.ok = function () {
                NodeShareLink.save($scope.link).$promise
                    .then(function (result) {
                        $scope.link = result;
                        $scope.modal.hideSubmitButton = true;
                        $scope.modal.cancelButton = 'Done';

                        $scope.$broadcast('remove.modal.notification');

                        $scope.cancel = $scope.close = function () {
                            $modalInstance.close('reload_nodes');
                        };
                    });
            };

            $scope.cancel = $scope.close = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.disableSubmit = function () {
                return ($scope.link.never_expire !== true && !$scope.link.ttl) ||
                    (angular.isFunction($scope.link.isPublicWithPassword) && $scope.link.isPublicWithPassword() && !$scope.link.password);
            };
        }]);
